<template>
  <div class="search-container">
    <input
        ref="input"
        type="text"
        :placeholder="placeholder"
        v-model="inputValue"
        @focus="handleFocus"
        @blur="handleBlur"
        @keyup.enter="handleEnter"
        class="search-input"
    />
    <i
        v-if="showIcon"
        class="el-icon-search search-icon"
        @click="handleEnter"
    ></i>
  </div>
</template>

<script>
export default {
  name: 'SearchInput',
  props: {
    // 支持 v-model 的 value
    value: {
      type: String,
      default: ''
    },
    // 自定义 placeholder
    placeholder: {
      type: String,
      default: '请输入关键字...'
    },
    // 是否显示搜索图标
    showIcon: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      inputValue: this.value
    }
  },
  watch: {
    value(newVal) {
      this.inputValue = newVal
    },
    inputValue(newVal) {
      this.$emit('input', newVal)
    }
  },
  methods: {
    handleEnter() {
      this.$emit('search', this.inputValue)
    },
    handleFocus(e) {
      this.$refs.input.style.border = '1px solid white'
      this.$emit('focus', e)
    },
    handleBlur(e) {
      this.$refs.input.style.border = '1px solid #24323e'
      this.$emit('blur', e)
    },
  }
}
</script>

<style scoped>
.search-container {
  position: relative;
  width: 100%;
  max-width: 400px;
}

.search-input {
  width: 100%;
  padding-right: 40px;
  height: 40px;
  padding-left: 12px;
  font-size: 16px;
  border: 1px solid #24323e;
  border-radius: 4px;
  outline: none;
  box-sizing: border-box;
  background-color: transparent;
  color: #fff;
}

.search-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  color: #fff;
  cursor: pointer;
  transition: color 0.3s ease;
}

.search-icon:hover {
  color: #007bff;
}
</style>
